<script>
import UserAvatar from '@/components/user/user-avatar.vue'
import candidateProfileImageMixin from '@/mixins/candidateProfileImageMixin'

export default {
  name: 'CandidateImage',
  components: { UserAvatar },
  mixins: [candidateProfileImageMixin],
  props: {
    size: {
      type: String,
      default: 'xxl',
    },
    fontSize: {
      type: Number,
      default: null,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    showPreferredIcon: {
      type: Boolean,
      required: false,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: null,
    },
    firstName: {
      type: String,
      default: null,
    },
    lastName: {
      type: String,
      default: null,
    },
    fullName: {
      type: String,
      default: null,
    },
  },
  data: () => {
    return {}
  },
  computed: {
    compFullName() {
      return (
        this.fullName ??
        (this.id > 0 ? `${this.firstName} ${this.lastName}` : '')
      )
    },
    profilePicture() {
      return this.$_candidateProfileImageMixin_profilePicture
    },
  },
  async created() {
    await this.$_candidateProfileImageMixin_loadCandidateDisplayPicture(this.id)
  },
}
</script>

<template>
  <div class="candidateImage mr-5">
    <UserAvatar
      :name="compFullName"
      :size="size"
      :font-size="fontSize"
      :clickable="id > 0 && clickable"
      :rounded="rounded"
      :badge="showPreferredIcon"
      badge-icon="mdi-star"
      badge-color="orange accent-2"
      :image-url="profilePicture"
      @click="$emit('click')"
    />
  </div>
</template>
